import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import { ProductType, PageType } from '../types/product.type';
import { SxHttpService } from '../../../infrastructure/services/sxHttp.service';
import { LayoutType } from '../types/layout-type';
import { SxDesignerService } from './designer-service';

interface PageTypeRequest {
    systemCode: string;
    businessCode: string;
    codProducto: string;
    codFlow: string;
    documentKind: string;
    standardkey: string;
    pageId: string;
    listPath: string;
    layout: LayoutType;
}

@Injectable()
export class SxfPageDesignerService implements SxDesignerService {
  url = 'api/sxpagefdesigner';

  constructor(private http: Http, private sxHttp: SxHttpService) {}

  get(page: PageType) {
    const reqUrl = `${this.url}/GetPage`;
    const req : PageTypeRequest = {
      systemCode: page.codSistema,
      businessCode: page.codNegocio,
      codProducto: page.codProducto,
      codFlow: page.flowId,
      documentKind: page.documentKind,
      standardkey: page.standardkey,
      pageId: page.id,
      listPath: page.listPath,
      layout: page.layout,
  }
    return this.sxHttp
      .post(reqUrl, req)
      .map(response => {
        page.layout = JSON.parse(response.json().data) as LayoutType;
        return page;
      })
      .catch(this.handleError)
      .toPromise();
  }

  save(page: PageType) {
    const reqUrl = `${this.url}/addOrUpdate`;
    const req : PageTypeRequest = {
      systemCode: page.codSistema,
      businessCode: page.codNegocio,
      codProducto: page.codProducto,
      codFlow: page.flowId,
      documentKind: page.documentKind,
      standardkey: page.standardkey,
      pageId: page.id,
      listPath: page.listPath,
      layout: page.layout,
  }

    return this.sxHttp
      .post(reqUrl, req)
      .catch(this.handleError)
      .toPromise()
      .then(this.extractData);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/page-service.ts